import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../services/data.service';
import { AvanzaPraticheService } from '../../../services/avanza-pratiche.service';
import { SocketService } from '../../../services/socket.service';

@Component({
  selector: 'app-avanza-pratiche',
  templateUrl: './avanza-pratiche.component.html',
  styleUrls: ['./avanza-pratiche.component.css']
})
export class AvanzaPraticheComponent implements OnInit {
	nextStateSelected = "all";
	nextStates: any = [];
	@Input() nextStep: any = {
		preselected : '',
		locked : false,
		idStatoAttuale: '',
		idStato: '',
		nomeStato: '',
		codiceStato: '',
		uids: [],
		comuneId: '',
		codiceComune: '',
		nomeComune: '',
		idEmissione: '',
		primoAtto: '',
		ultimoAtto: ''
	};
	@Input() writePermission: boolean = false;
	@Input() datiRettifica: string = '';

	@Output() innerEvents = new EventEmitter();
	@Output() rettificaPraticaOut = new EventEmitter();

	messiSync: Subscription;
	responsabiliSync: Subscription;
	spedizioniSync: Subscription;
	statesDictSync: Subscription;
	activeFlowSync: Subscription;

	gruppo: any = null;
	messi: any[] = [];
	responsabili: any[] = [];
	spedizioni: any[] = [];
	statesDict: any = null;
	activeFlow: any = null;

	params: any = {
		responsabile_tributo	: null,
		protocollo_num			: null,
		protocollo_data			: null,
		spedizione_tipo			: null,
		spedizione_data			: null,
		spedizione_ufficio		: null,
		raccomandata_num		: null,
		interessi_tipo			: null,
		interessi_data			: null,
		messo_notificatore		: null,
		cronologico_num			: null,
		cronologico_data		: null,
		num_rate				: 1,
		inizio_rate_data		: null,
		motivazione				: null,
		rettifica				: null
	};

	modalInput: any = {
		size: '',
		title: '',
		subtitle: '',
		data: {
			id: 0,
			crc: 0,
			person: null,
			uid: null,
			id_prat: null,
			reset: false,
		}
	};

	constructor(
		private dataService: DataService,
		private avanzaPratiche: AvanzaPraticheService,
		private socketService: SocketService
		) {}

	ngOnInit() {
		this.messiSync = this.dataService.messiNotificatori$.subscribe(
			messi => {
				this.messi = messi;
				if(this.messi){
					this.params["messo_notificatore"] = this.messi[0].id;
				}else{
					console.log("Nessun Messo Notificatore");
				}
			}
		);
		this.responsabiliSync = this.dataService.responsabiliTributo$.subscribe(
			responsabili => {
				this.responsabili = responsabili;
				if(this.responsabili){
					this.params["responsabile_tributo"] = this.responsabili[0].id;
				}else{
					console.log("Nessun Responsabile Tributo");
				}
			}
		);
		this.spedizioniSync = this.dataService.tipiSpedizione$.subscribe(
			spedizioni => {
				this.spedizioni = spedizioni;
			}
		);
		this.statesDictSync = this.dataService.statesDict$.subscribe(
			statesDict => {
				this.statesDict = statesDict;
			}
		);
		this.activeFlowSync = this.dataService.activeFlow$.subscribe(
			activeFlow => {
				this.activeFlow = activeFlow;
				//console.log("activeflow", this.activeFlow);
				if(this.nextStep.idStatoAttuale) {
					for(let state of this.activeFlow.contenuto.workflow.connections[this.nextStep.idStatoAttuale]){
						//console.log("activeflow statesDict", this.statesDict[state]);
						if(this.statesDict[state].atto)
							this.nextStates.push(this.statesDict[state]);
					}
					if (this.nextStates.length && !this.nextStep.preselected.length) {
						this.nextStateSelected = this.nextStates[0].id;
					}
				}
			}
		);
	}

	ngOnChanges(changes: any){
		console.log('CHANGE AVANZA PRATICA', changes);
		if (changes.datiRettifica && this.datiRettifica.length) {
			console.log('CHANGE DATI RETTIFICA AVANZA', this.datiRettifica, this.params.rettifica);
			this.params.rettifica = JSON.parse(this.datiRettifica);
		}
		if (changes.nextStep) {
			console.log('CHANGE NEXTSTEP', this.nextStep);
			this.nextStateSelected = this.nextStep.preselected;
			console.log('CHANGE NEXTSTEP', this.nextStateSelected);
		}
	}

	reset(){
		console.log('PARAMS PRE', this.params);
		for (let param in this.params){
			switch(param){
				case 'num_rate':{
					this.params[param] = 1;
					break;
				}
				case 'rettifica':{
					this.params[param] = false;
					break;
				}
				default:{
					this.params[param] = null;
				}
			}
		}
		this.datiRettifica = '';
		console.log('PARAMS', this.params);
	}

	hide(){
		this.reset();
		let event: any = {
			hide : true
		}
		this.innerEvents.emit(event);
	}

	checkProcedi() {
		if (this.checkDefaultParams() && this.checkIngiunzioneParams()) {
			return true;
		}
		else {
			return false;
		}
	}

	checkDefaultParams() {
		if (
			this.params.responsabile_tributo != null &&
			this.checkProtocollo() &&
			this.checkInteressi() &&
			this.checkSpedizioni()
			) {
			return true;
		}
		return false;
	}

	checkProtocollo() {
		let check: boolean = true;
		if (this.params.protocollo_num != null && this.params.protocollo_num != '') {
			check = false;
			if (this.params.protocollo_data != null && this.params.protocollo_data != '') {
				check = true;
			}
		}
		return check;
	}

	checkSpedizioni() {
		let check: boolean = false;
		if (this.params.spedizione_tipo != null) {
			check = true;
			if (this.params.spedizione_tipo == 1 || this.params.spedizione_tipo == 2) {
				check = true;
				if (this.params.raccomandata_num != null && String(this.params.raccomandata_num).length != 11) {
					check = false;
				}
			}
			// if (this.params.spedizione_tipo != 4 && this.params.spedizione_tipo != 5) {
			// 	check = false;
			// 	if (this.params.spedizione_ufficio != null && this.params.spedizione_ufficio != '') {
			// 		check = true;
			// 	}
			// 	if (this.params.spedizione_tipo != 3) {
			// 		check = false;
			// 		if (this.params.raccomandata_num != null && this.params.raccomandata_num.length == 11) {
			// 			check = true;
			// 		}
			// 	}
			// }
		}
		return check;
	}

	checkInteressi() {
		let check: boolean = true;
		if (Number(this.nextStateSelected) == 7 || Number(this.nextStateSelected) == 7) {
			check = false;
			if (this.params.interessi_tipo != null ) {
				check = true;
			}
		}
		return check;
	}

	checkIngiunzioneParams() {
		let check: boolean = true;
		// if (Number(this.nextStateSelected) == 5) {
		// 	check = false;
		// 	if (this.params.messo_notificatore != null) {
		// 		check = true;
		// 		if (this.params.cronologico_num != null && this.params.cronologico_num != '') {
		// 			check = false;
		// 			if (this.params.cronologico_data != null && this.params.cronologico_data != '') {
		// 				check = true;
		// 			}
		// 		}
		// 	}
		// }
		return check;
	}

	procedi() {
		this.gruppo = this.dataService.getTemplatesGruppiByUid(this.nextStep.uids[0]);
		console.log('GRUPPO: ', this.gruppo, this.params);
		if(Number(this.params.idAtto) != 7 && Number(this.params.idAtto) != 2 && this.params.interessi_tipo == null){
			this.params.interessi_tipo = "legali";
			let today = new Date();
			let dd = String(today.getDate());
			let mm = String(today.getMonth()+1); //January is 0!
			let yyyy = String(today.getFullYear());

			if(Number(dd) < 10){
				dd ='0'+dd;
			}
			if(Number(mm) < 10){
				mm ='0'+mm;
			}
			if(this.params.protocollo_data == null){
				this.params.interessi_data = yyyy+"-"+mm+"-"+dd;
			}else{
				this.params.interessi_data = this.params.protocollo_data;
			}
		}
		let body: any = {
			clientId: this.socketService.getClientId(),
			comuneId: this.nextStep.comuneId,
			nomeComune: this.nextStep.nomeComune,
			codiceComune: this.nextStep.codiceComune,
			idGruppo: this.gruppo.id,
			nomeGruppo:  this.gruppo.codice.toLowerCase(),
			idAtto: Number(this.nextStateSelected),
			nomeAtto: this.statesDict[Number(this.nextStateSelected)].codice.toLowerCase(),
			params: this.params,
			uids: this.nextStep.uids,
			primoAtto: this.nextStep.primoAtto,
			ultimoAtto: this.nextStep.ultimoAtto,
			bollettino: this.statesDict[Number(this.nextStateSelected)].bollettino,
			rate: this.statesDict[Number(this.nextStateSelected)].rate,
			atto: this.statesDict[Number(this.nextStateSelected)].atto
		}
		console.log('avanza pratica body: ', body);
		this.avanzaPratiche.mandaAvanti(body);
		this.hide();
	}

	rettificaPratica() {
		console.debug("AVANZA-PRATICHE| RETTIFICAPRATICA");
		this.rettificaPraticaOut.emit({ rev : false });
	}

	rettificaPraticaRev() {
		console.debug("AVANZA-PRATICHE| RETTIFICAPRATICA REV", this.params.rettifica, ".ret!!!");
		this.rettificaPraticaOut.emit({ rev : true , data : this.params.rettifica });
	}

	ngOnDestroy() {
		this.messiSync.unsubscribe();
		this.responsabiliSync.unsubscribe();
		this.spedizioniSync.unsubscribe();
		this.statesDictSync.unsubscribe();
		this.activeFlowSync.unsubscribe();
	}
}
